/* eslint-disable max-len */
import { Col, Row } from 'antd';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import { ECrsStav, ICrsHistorie, ICrsHistorieDotaznik, crsHistorieGet, crsZruseni } from 'services/poDlt/crs';

import { ENotificationType } from 'enums/notificationType';
import routePathEnum from 'enums/routePathEnum';

interface ICrsHistoriePage {}

const CrsHistorie: React.FC<ICrsHistoriePage> = () => {
    const { aktivniFirma, NotificationComponent } = useContext(Context);
    const [zadosti, setZadosti] = useState<ICrsHistorie>();
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [offset, setOffset] = useState<number>(0);
    const [refetch, setRefetch] = useState<boolean>(false);

    const columns = [
        {
            title: <TranslateText>EMP_PODANE_ZADOSTI_DATUM_PODANI</TranslateText>,
            dataIndex: 'datum',
            key: 'datum',
            render: (text: string) => dayjs(text).format('DD.MM.YYYY')
        },

        {
            title: <TranslateText>EMP_PODANE_ZADOSTI_STAV</TranslateText>,
            dataIndex: 'stav',
            key: 'stav',

            render: (text: string) => <TranslateText>{`CRS_STAV_${text}`}</TranslateText>
        },
        {
            dataIndex: 'iddot',
            key: 'iddot',
            width: 215,
            render: (iddot: string, row: ICrsHistorieDotaznik, index: number) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-evenly'
                    }}
                >
                    {row.stav !== ECrsStav.ZRUS && (
                        <AnchorComponent
                            link={true}
                            to={
                                aktivniFirma
                                    ? `/firma/${aktivniFirma?.iducet}/${routePathEnum.CRS_DOTAZNIK_NOVY.split('/')[1]}/${iddot}`
                                    : ''
                            }
                            id={`pokracovatCrs${index}`}
                        >
                            {row.stav === ECrsStav.ROZP ? (
                                <TranslateText>POKRACOVAT</TranslateText>
                            ) : (
                                <TranslateText>ZOBRAZIT</TranslateText>
                            )}
                        </AnchorComponent>
                    )}
                    {row.stav === ECrsStav.ROZP && (
                        <AnchorComponent
                            id={`zrusitCrs${index}`}
                            link={true}
                            onClick={() => {
                                setLoading(true);
                                crsZruseni(row.iddot)
                                    .then(() => {
                                        NotificationComponent({
                                            title: 'ZRUSIT_ZADOST',
                                            description: 'ZRUSIT_ZADOST_SUCCESS',
                                            type: ENotificationType.SUCCESS
                                        });
                                    })
                                    .finally(() => {
                                        setLoading(false);
                                        setRefetch(pv => !pv);
                                    });
                            }}
                        >
                            <TranslateText>ZRUSIT_ZADOST</TranslateText>
                        </AnchorComponent>
                    )}
                    {/* row.stav === ECrsStav.ZPRAC && (
                        <AnchorComponent
                            id={`zrusitCrs${index}`}
                            link={true}
                            onClick={() => {
                                setLoading(true);
                                crsPDFdownload(
                                    row.iddot,
                                    `${getLanguageObject(language).DOTAZNIK_CRS}${dayjs(row.datum).format('DD.MM.YYYY')}.pdf`
                                ).finally(() => setLoading(false));
                            }}
                        >
                            <TranslateText>ZRUSIT_ZADOST</TranslateText>
                        </AnchorComponent>
                    )*/}
                </div>
            )
        }
    ];

    useEffect(() => {
        // nacitanie dat pri zmene strany v table
        setLoading(true);
        setErrStatus(0);
        crsHistorieGet({
            order: 'id:desc',
            limit: 10,
            offset: offset
        })
            .then(resp => {
                setZadosti(resp);
            })
            .catch((err: any) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offset, refetch]);

    return (
        <>
            {errStatus && errStatus !== 404 ? (
                <Row
                    justify="center"
                    align="middle"
                    style={{
                        height: '100%'
                    }}
                >
                    <Col span={16} flex={'0 0 auto'}>
                        <LoadingWrapper loading={loading}>
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        </LoadingWrapper>
                    </Col>
                </Row>
            ) : (
                <LoadingWrapper loading={loading}>
                    <Title level={3} text="PODANE_DOKUMENTY" />
                    <Row gutter={8}>
                        <Col span={24}>
                            <TableComponent
                                columns={columns}
                                rowKey={record => record.iddok}
                                dataSource={zadosti?.dotazniky}
                                locale={{
                                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                                }}
                                pagination={{
                                    total: zadosti?.count,
                                    onChange: page => setOffset((page - 1) * 10),
                                    current: offset / 10 + 1,
                                    showSizeChanger: false
                                }}
                                rowClassName={(_a, i) => {
                                    const classes = [];
                                    if (i % 2) classes.push('tableRowGray');
                                    return classes.join(' ');
                                }}
                            />
                        </Col>
                    </Row>
                </LoadingWrapper>
            )}
        </>
    );
};

export default CrsHistorie;
